import { useEffect, useState } from "react";

const isDocumentVisible = (): boolean =>
  typeof document === "undefined" || document.visibilityState === "visible";

/**
 * PRODUCT_DEV-652: タブが表示中かどうかを返す。
 *
 * ポーリングを裏タブで止めるための共通判定。`visibilitychange` に加えて `pageshow` も見るのは、
 * bfcache 復帰では `visibilitychange` が発火しない環境があるため
 * （`packages/shared-ui/hooks/useScreenWakeLock.ts` と同じ理由・同じ扱い）。
 */
export function usePageVisible(): boolean {
  const [visible, setVisible] = useState(isDocumentVisible);

  useEffect(() => {
    const sync = () => setVisible(isDocumentVisible());
    document.addEventListener("visibilitychange", sync);
    window.addEventListener("pageshow", sync);
    return () => {
      document.removeEventListener("visibilitychange", sync);
      window.removeEventListener("pageshow", sync);
    };
  }, []);

  return visible;
}
